<template>
  <ModalWrapper :model-name="modelName">
    <div class="register-now-modal">
      <div class="register-now-modal-head">
        <img class="register-now-modal-head_img" src="@/assets/img/want-more.png" alt="close remove" />
        <div class="register-now-modal-head_img-text">
          <img src="@/assets/img/want-more-text.png" alt="want more text" />
        </div>
        <div @click="onClose" class="register-now-modal-head_close">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18.835 18.8847C19.2832 18.4276 19.2832 17.6805 18.8438 17.2411L13.6494 12.0468L18.8438 6.84364C19.2832 6.40418 19.292 5.64832 18.835 5.20008C18.3867 4.75184 17.6309 4.75184 17.1914 5.19129L11.9971 10.3856L6.79395 5.19129C6.37207 4.76063 5.59863 4.74305 5.15039 5.20008C4.70215 5.64832 4.71094 6.42176 5.1416 6.84364L10.3359 12.0468L5.1416 17.2411C4.71094 17.6718 4.70215 18.4364 5.15039 18.8847C5.60742 19.3329 6.37207 19.3241 6.79395 18.9022L11.9971 13.6991L17.1914 18.8934C17.6309 19.3329 18.3867 19.3329 18.835 18.8847Z" />
          </svg>
        </div>
      </div>

      <div class="register-now-modal_body">
        <p class="register-now-modal_info-des">
          <span class="green-text">Sign up and get 1 free generation</span> — choose your fantasy: lingerie or latex. <br> Turn your imagination into reality.
        </p>
        <div class="image-holder">
          <img
              :src="bikiniImage"
              alt="collage part"
              class="collage-item"
          />
          <img
              :src="underwearImg"
              alt="collage part"
              class="collage-item"
          />
        </div>
        <p class="register-now-modal_info-des mt-10 mb-10">
          <span class="red-text">Top up within 15 minutes and get 80% off your first credit pack</span> (starting from $2 with promo code).
          Full nudity and a variety of erotic poses — available after topping up your balance.
        </p>
        <div class="register-now-modal_info-promo mt-10">
          <p class="register-now-modal_info-des">
            Promo Code:
          </p>
          <button
              @click="copyPromoCode"
          >
            {{ promoCode }}
          </button>
        </div>
        <span>Copy and use it at checkout.</span>
      </div>
      <div class="register-now-modal_footer">
        <button
          @click="redirectToRegistration"
          class="register-now-modal_button"
        >
          Sign Up
        </button>
      </div>
    </div>
  </ModalWrapper>
</template>

<script>
import bikiniImage from "@/assets/filters-bikini/black.webp";
import underwearImg from "@/assets/filter-underwear/black.webp";
import ModalWrapper from "@/components/modals/ModalWrapper.vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { ref  } from "vue";
export default {
  name: "RegisterNowModal",
  components: {
    ModalWrapper,
  },
  props: {
    modelName: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const { locale } = useI18n()
    const router = useRouter();
    const promoCode = ref('SMNKD80');
    const onClose = () => {
      store.commit("removeAllModal");
      emit("closeModal");
    };

    const copyPromoCode = async () => {
      try {
        await navigator.clipboard.writeText(promoCode.value);
        store.dispatch("handleToast", {
          text: "Promo code copied!",
          type: "SUCCESS",
        });
      } catch (err) {
        console.error('Copy failed:', err);
      }
    };

    const redirectToRegistration = () => {
      store.commit("removeAllModal");
      emit("closeModal");
      router.push("/sign-up");
    };

    return {
      locale,
      onClose,
      redirectToRegistration,
      bikiniImage,
      underwearImg,
      copyPromoCode,
      promoCode,
    };
  },
};
</script>

<style lang="scss" scoped>
.register-now-modal {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  margin: 0 auto;
  max-width: 550px;
  width: 95%;
  overflow: auto;
  border-radius: 30px;
  border: 2px solid #ACF601;
  background: #2C2B2B;
  max-height: 90vh;
  &-head {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    border-radius: 0px 0px 200px 200px;
    background: #ACF601;
    overflow: hidden;
    position: relative;
    margin-bottom: 24px;

    &_img {
      width: 100%;
      max-width: 140px;
      font-size: 0;

      @media screen and (max-width: 530px) {
        max-width: 140px;
      }

      &-text {
        position: absolute;
        top: 50%;
        right: 20%;
        transform: translateY(-50%);
        max-width: 273px;
        width: 100%;
        z-index: 1;

        @media screen and (max-width: 530px) {
          max-width: 173px;
          right: 10%;
        }

        img {
          width: 100%;
          max-width: 100%;
        }
      }
    }
    &_close {
      cursor: pointer;
      position: absolute;
      right: 25px;
      top: 25px;
      width: 49px;
      height: 38px;
      background: #4C4C4C;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      @media screen and (max-width: 1024px) {
        right: 2.1vw;
        top: 2.1vw;
      }

      svg {
        width: 24px;
        height: 24px;
        fill: #ACF601;
      }
    }
  }
  &_body {
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    //gap: 25px;
    padding: 0 25px 25px;

    @media screen and (max-width: 530px) {
      padding: 0 15px 15px;
    }
  }

  &_info {
    color: #FFF;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    max-width: 270px;
    line-height: 100%;
    text-transform: capitalize;

    span {
      color: #ACF601;
    }
    &-promo {
      //register-now-modal_info-promo
      display: flex;

      button {
        cursor: pointer;
        border: none;
        outline: none;
        border-radius: 20px;
        background: #ACF601;
        color: #000;
        text-align: center;
        font-size: 16px;
        font-weight: 700;
        text-transform: capitalize;
        padding: 0 10px;
        margin-left: 10px;
      }
    }
    &-des {
      font-size: 18px;
      text-transform: capitalize;
      text-align: center;
      font-weight: bold;

      @media screen and (max-width: 530px) {
        font-size: 16px;
      }

      @media screen and (max-width: 390px) {
        font-size: 14px;
      }
    }


  }

  &_footer {
    padding: 0 25px 25px;
    display: flex;
    justify-content: center;

    @media screen and (max-width: 530px) {
      padding: 0 15px 15px;
    }
  }

  &_button {
    border: none;
    width: 100%;
    min-width: 258px;
    box-shadow: 1px 2px 10px #67eb00;
    outline: none;
    transition: all 0.3s;
    border-radius: 20px;
    background: #ACF601;
    height: 60px;
    color: #000;
    text-align: center;
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
    text-transform: capitalize;
    &:hover {
      box-shadow: 1px 2px 25px #67eb00;
      color: rgba(0, 0, 0, 1);
    }
    &--disabled {
      opacity: 0.55;
      cursor: not-allowed;
    }

    @media screen and (max-width: 1024px) {
      font-size: 20px;
      height: 50px;
      border-radius: 10px;
    }

    @media screen and (max-width: 768px) {
      font-size: 16px;
      height: 40px;
      border-radius: 8px;
    }

    @media screen and (max-width: 650px) {
      width: 100%;
    }
  }

  .image-holder {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 20px 20px 10px;
    width: 100%;
    img {
      overflow: hidden;
      border-radius: 20px;
      background: #FFF;
      width: 190px;
      height: 220px;
      margin-bottom: 6px;
    }

    @media screen and (max-width: 530px) {
      margin: 20px 0 10px;
    }

    @media screen and (max-width: 450px) {
      img {
        width: 150px;
        height: 200px;
      }
    }
  }
}
</style>
